import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const HotelIcon = ({ title = 'Hotel', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    {/* prettier-ignore */}
    <g transform="translate(12 8)" fill="none" fillRule="evenodd" stroke="currentColor">
      <circle cx="4" cy="48.5" r="2" />
      <circle cx="37" cy="48.5" r="2" />
      <path d="M.5 46h40" strokeLinecap="round" />
      <path d="M2 21.995C2 12.056 10.057 4 20 4c9.941 0 18 8.06 18 17.995V46H2V21.995Z" />
      <path d="M18.5 1.5h4" strokeLinecap="round" />
      <path d="M20.5 1.5v2M23.5 34v9M32.5 34v9" strokeLinecap="square" />
      <path strokeLinejoin="round" d="M5 23.5h14v20H5zM21 33.5h14v10H21zM9 20.5h6v3H9zM26 30.5h4v3h-4z" />
      <path d="M5.5 28h13M5.5 30h13" strokeLinecap="square" />
    </g>
  </CreateIconComponent>
);

export default HotelIcon;
